import { IDENTITY_STATE, IDENTITIES_KEYS_SPECIAL, } from '../types';
import { setCache } from './cache';
import { isAvailable } from './config';
import { EVENT_NAME } from './consts';
import { debug } from './debug';
import { sendEvent } from './events';
import { feedChildFrames } from './frames';
import { createIdentityObject, validateIdentificator, validateValueType } from './identities';
import { runSubscribers } from './subscribing';
import { isObject } from './utils';
/**
 * Cache storage state and notify rest of the world (send events / post messages, run subscribers).
 */
export const cacheAndNotify = (encoded, identities, changes) => {
    if (encoded) {
        setCache(encoded);
    }
    runSubscribers({ identities, changes });
    sendEvent(EVENT_NAME, { identities, changes });
    feedChildFrames({ identities });
    debug('Cached and notified');
};
/**
 * Get value from identity (root or by dot notation -> sublevel of value object).
 */
export const getValueLevel = (identificator, identityValue) => {
    var _a;
    const identificatorSplit = identificator.split('.');
    const subSplit = identificatorSplit.slice(1);
    const reducer = (data) => subSplit.reduce((acc, key) => (acc || {})[key], data);
    const value = (identityValue === null || identityValue === void 0 ? void 0 : identityValue.value) || identityValue;
    const isValueObject = isObject(value);
    const isRich = !!(identityValue === null || identityValue === void 0 ? void 0 : identityValue.value);
    let subValue = null;
    if (subSplit.length) {
        subValue = isValueObject ? (_a = reducer(value)) !== null && _a !== void 0 ? _a : null : null;
    }
    else {
        subValue = value;
    }
    return isRich ? (subValue !== null ? Object.assign(Object.assign({}, identityValue), { value: subValue }) : null) : subValue;
};
/**
 * Create IDENTITY parcial object from each value ({value: ...})
 */
export const createValuesObjects = (identities, createValueForSpecial) => {
    const specials = {}; // special identities (rusId, said, ...)
    return Object.keys(identities).reduce((acc, key) => {
        let keyHandled = key;
        let valueHandled = identities[key];
        // is special identity?
        if (key in IDENTITIES_KEYS_SPECIAL) {
            const k = key;
            // transform key to main identity and prepare wrapped value
            keyHandled = createValueForSpecial(k, valueHandled, specials);
            if (keyHandled) {
                valueHandled = specials[keyHandled];
            }
        }
        if (keyHandled && valueHandled) {
            acc[keyHandled] = { value: valueHandled };
        }
        return acc;
    }, {});
};
/**
 * Sanitize submited identities.
 * Filter not supported ones.
 */
export const sanitizeIdentities = (storage, newIdentities) => {
    const sanitedIdentities = {};
    if (!isObject(newIdentities)) {
        debug({ type: 'warn', message: `Submited identities data are invalid`, newIdentities });
        return {};
    }
    Object.keys(newIdentities).forEach((iKey) => {
        if (validateIdentificator(iKey)) {
            const k = iKey;
            const identityObject = newIdentities[k];
            const valueValidated = validateValueType(k, identityObject.value);
            if (!isAvailable(k) || !valueValidated.ok) {
                return;
            }
            identityObject.value = valueValidated.value;
            const valueObject = Object.assign({ state: IDENTITY_STATE.fresh, settled: true }, identityObject);
            sanitedIdentities[k] = createIdentityObject(storage[k], valueObject.value, valueObject.state, true);
        }
    });
    return sanitedIdentities;
};
